import { createContext } from 'react';

export interface CurrencyContextValue {
    currency: string;
    setCurrency: (currency: string) => void;
}

export const CurrencyContext: React.Context<CurrencyContextValue> = createContext<CurrencyContextValue>({
    currency: 'SEK',
    setCurrency: () => undefined,
});
